import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from '@environment';
import { SceneStore } from '@stores';
import { sceneMeta } from '../../scenes/scene-meta';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private sceneStore = inject(SceneStore);

  baseUrl = environment.API_HOST;
  activeParams: string;
  activeReportGuid: string;
  activeConferenceScene: string;
  context: string;
  targetRoute: string;
  courseEntry: string;

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.targetRoute = this.route.snapshot.queryParams['origin'];
        this.courseEntry = this.route.snapshot.queryParams['courseEntry'];
        this.context = this.context ?? '7c7d351f-0967-46ef-8152-a0e2ed674bd3';
        // neverending context: '7c7d351f-0967-46ef-8152-a0e2ed674bd3'
        const sceneIdentifier =
          this.sceneStore.data().identifier ??
          this.route.snapshot.queryParams['sceneIdentifier'] ??
          sceneMeta[this.route.snapshot.queryParams['scene']]?.identifier ??
          null;
        sessionStorage.clear();
        if (sceneIdentifier !== this.sceneStore.data().identifier) {
          this.sceneStore.getSceneData(sceneIdentifier);
        }
      }
    });
  }
}
